var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetProjectElementLarge',{attrs:{"title":_vm.pointOfInterest.title,"subtitle":_vm.pointOfInterest.shortText,"logo-image-url":_vm.logoUrl,"preview-image-url":_vm.previewImageUrl,"enter-to":_vm.pointOfInterestEnterToLink,"exterior-tour360-to":_vm.pointOfInterestTour360ToLink}})
}
var staticRenderFns = []

export { render, staticRenderFns }